export default __webpack_public_path__ + "static/media/tinyDaoRight1.749388d5.png";